import './App.css'
import Header from './Common/Header/Header'
import Auth from './Components/Auth/Auth'
import { Routes, Route } from 'react-router-dom'
import Users from './Components/users/Users'
import { useSelector, useDispatch } from 'react-redux'
import Admin from './Components/admin/Admin'
import Accounts from './Components/Accounts/Accounts'
import WinningLots from './Components/Lots/WinningLots'
import OpenItemsLots from './Components/Lots/OpenItemsLots'
import NotPaid from './Components/Lots/NotPaid'
import History from './Components/Lots/History'
import Logs from './Components/Logs/Logs'
import { useEffect } from 'react'
import axios from 'axios'
import { usersActions } from './store/user'
import Landing from './Components/Landing/Landing'
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy'
import Contact from './Components/Contact/Contact'
import ContactSubmitted from './Components/Contact/ContactSubmitted'

function App() {
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + '/api/admin')
      .then(response => {
        const data = response.data.data
        dispatch(usersActions.changeIsLoggedIn(true))
        dispatch(usersActions.setLoggedInHandler(data.role))
      })
      .catch(err => {
        dispatch(usersActions.changeIsLoggedIn(false))
      })
  }, [dispatch])

  return (
    <div className="App">
      {user.isLoggedIn === true && <Header />}
      <Routes>
        <Route path="/sign-up" element={<Landing />} />

        <Route path="/" element={user.isLoggedIn ? <Users /> : <Auth />} />

        <Route path="/users/:username" element={user.isLoggedIn ? <Users /> : <Auth />} />

        <Route path="/lots/winning" element={user.isLoggedIn ? <WinningLots /> : <Auth />} />

        <Route path="/lots/open-items" element={user.isLoggedIn ? <OpenItemsLots /> : <Auth />} />

        <Route path="/lots/not-paid" element={user.isLoggedIn ? <NotPaid /> : <Auth />} />

        <Route path="/lots/history" element={user.isLoggedIn ? <History /> : <Auth />} />

        <Route path="/admins" element={user.isLoggedIn ? <Admin /> : <Auth />} />

        <Route path="/accounts" element={user.isLoggedIn ? <Accounts /> : <Auth />} />

        <Route path="/logs" element={user.isLoggedIn ? <Logs /> : <Auth />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="/contact/success" element={<ContactSubmitted />} />
      </Routes>
    </div>
  )
}

export default App
